import { DataLayer } from '@grandvisionhq/analytics';

const ContactLensesConfigEvent = 'ContactLensesConfigEvent';
const pushSelectBoxQuantity = (totalPrice, frequency, quantity)=>{
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select box quantity',
        eventLabel: undefined,
        RxContactLenses: {
            productConfig: {
                price: `${totalPrice.centAmount / 100}`,
                box: {
                    frequency,
                    quantity
                }
            }
        }
    });
};
const pushPrescriptionChange = (attribute, value, side)=>{
    DataLayer.pushEvent({
        event: ContactLensesConfigEvent,
        eventAction: 'select rx attribute',
        eventLabel: `${attribute} ${side}`,
        RxContactLenses: {
            productConfig: {
                lens: {
                    [side === 'left' ? 'OS' : 'OD']: {
                        [attribute]: value
                    }
                }
            }
        }
    });
};

export { pushPrescriptionChange, pushSelectBoxQuantity };
//# sourceMappingURL=data-layer.js.map
